enum ROLES_ENUM {
  ADMIN = "admin",
  USER = "user",
}

export default ROLES_ENUM;
